import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarCategoriaConfiguracion } from '../../../actions/configuracion';

const EliminarCategoria = ({ categoria, reestablecerCategoria }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar categoria */
    const handleProcesar = async (tipo) => {
        await setStatusProcesar(true);
        await dispatch(eliminarCategoriaConfiguracion({
            _id: categoria?._id, 
            tipo
        }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerCategoria(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(categoria){
            setEliminarModal(true);
        }
    }, [categoria]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar categoria</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar a <b>{categoria?.nombre}{categoria?.subcategorias > 0 ? ' con ' + categoria?.subcategorias + (categoria?.subcategorias === 1 ? ' subcategoria asignada' : 'subcategorias asignadas') : ''}</b>?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si, solo categoria</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si, categoria y subcategorias</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar(1)}><i className="fas fa-check fa-sm"></i> Si, solo categoria</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar(2)}><i className="fas fa-check fa-sm"></i> Si, categoria y subcategorias</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarCategoria;